import { render } from "./ArchiveStorageManufacturerList.vue?vue&type=template&id=2e1d6cec&scoped=true"
import script from "./ArchiveStorageManufacturerList.vue?vue&type=script&lang=js"
export * from "./ArchiveStorageManufacturerList.vue?vue&type=script&lang=js"

import "./ArchiveStorageManufacturerList.vue?vue&type=style&index=0&id=2e1d6cec&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1d6cec"]])

export default __exports__